import React, { useEffect, useState } from "react";
import CustomTable from "../../components/CustomTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faReceipt } from "@fortawesome/free-solid-svg-icons";
import "../CaseDetails/CaseDetails.css";
import API from "../../api/axiosConfig";
import TestPreLoader from "../TestPreLoader/TestPreLoader";
import TableComponent from "../../components/TableComponent";

function BeneficiaryX(props) {

    const columns = [
        { name: "إسم المستفيد", key: "name" },
        { name: "الحالة", key: "status_string" },
        { name: "السبب", key: "note" },
        { name: "", key: "actions" },
    ];
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState([]);



    const dropdownOptions = [
         { label: "دراسة حالة", route: "/casestudy/:id" },
    ];


    const handleDownload = (selectedRows) => {
        const selectedData = rows.filter((row) => selectedRows.includes(row.id));
        if (selectedData.length === 0) {
            alert("Please select at least one row.");
            return;
        }

        const csvHeader = columns
            .filter((col) => col.key !== "actions")
            .map((col) => col.name)
            .join(",");

        const csvRows = selectedData.map((row) =>
            columns
                .filter((col) => col.key !== "actions")
                .map((col) => `"${row[col.key] || ""}"`)
                .join(",")
        );

        const csvContent = `${csvHeader}\n${csvRows.join("\n")}`;

        const bom = "\uFEFF";
        const finalContent = bom + csvContent;

        const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "selected_rows_report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // useEffect(() => {
    //     getHumanCases();
    // }, []);
  
    return (
        
        <>
            <div className="printcasedata-container">

               

                <TableComponent
                            apiUrl="/humancases/rejected"
                            columns={columns}
                            title="تقرير المستبعدون"
                            titleIcon={<FontAwesomeIcon icon={faReceipt} />}
                            dropdownOptions = {dropdownOptions}
                            searchTextProp={true}
                            searchDate={false}
                          />
            </div>
        </>
    );
}

export default BeneficiaryX;
